<style lang="less" rel="stylesheet/less" scope>
@import url('./../css/common.less');
</style>
<template>
  <div class="login-wrapper" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.2)">
    <div v-show="!isLoading">
      <header>
        <span class="header-img">
          <img
            v-if="competentData.logoImgUrl"
            :src="BASE_API + competentData.logoImgUrl"
            alt
            id="img1"
          />
          <img v-if="competentData.showDefaultHeader" src="./../../../assets/login/header.jpg" alt />
        </span>
      </header>
      <section ref="section">
        <el-row class="main-row">
          <el-col :xs="12" :sm="12" :md="12" :lg="12" :offset="2">
            <div class="img-box" id="img-box">
              <img
                v-if="competentData.centerImgUrl"
                :src="BASE_API + competentData.centerImgUrl"
                alt
              />
              <img
                v-if="competentData.showDefaultCenter"
                src="./../../../assets/login/login-default.jpg"
                alt
              />
            </div>
          </el-col>
          <el-col :xs="6" :sm="6" :md="5" :lg="5" :offset="2">
            <login-board-normal ref="login"></login-board-normal>
          </el-col>
        </el-row>
      </section>
      <footer class="effect">
        <ul>
          <li>
            <span v-show="competentData.sponsoringDept">
              主管部门：
              <a
                class="info"
                :href="competentData.sponsoringDeptLink"
                :class="{'foot-hover':competentData.sponsoringDeptLink}"
                target="_blank"
              >{{competentData.sponsoringDept}}</a>
            </span>
            <span v-show="competentData.competentOgn">
              主办单位：
              <a
                class="info"
                :href="competentData.competentOgnLink"
                :class="{'foot-hover':competentData.competentOgnLink}"
                target="_blank"
              >{{competentData.competentOgn}}</a>
            </span>
          </li>
          <li>
            <span class="other-item" v-if="otherConfig.name">
              <img :src="otherConfig.img" alt="图标" />
              <span>{{otherConfig.name}}：</span>
              <a
                class="info"
                :href="otherConfig.link"
                :class="{'foot-hover':otherConfig.link}"
                target="_blank"
              >{{otherConfig.company}}</a>
            </span>
            <span class="footer-item techSupport" v-show="competentData.techSupport">
              技术支持：
              <a
                class="info"
                :href="competentData.techSupportLink"
                :class="{'foot-hover':competentData.techSupportLink}"
                target="_blank"
              >{{competentData.techSupport}}</a>
            </span>
            <span class="footer-item customerTelephone" v-show="competentData.customerTelephone">
              客服电话：
              <a target="_blank">{{competentData.customerTelephone}}</a>
            </span>
            <span
              class="other-item"
              v-if="otherConfig&&otherConfig.webNumber"
            >网站备案号：{{otherConfig.webNumber}}</span>
          </li>
        </ul>
      </footer>
      <ly-customer-board class="customer"></ly-customer-board>
      <!-- 温馨提示 -->
      <div class="message" v-if="rule">
        <div v-show="message">
          <el-dialog
            title="温馨提示"
            :visible.sync="dialogVisible"
            :modal="false"
            :close-on-click-modal="false"
            :before-close="handleDialogClose"
            style="white-space:pre-line;word-wrap: break-word; line-height:25px;"
          >
            <p><b>{{rule.p1}}</b></p>
            <p>{{rule.p2}}</p>
            <p>{{rule.p3}}</p>
            <p>{{rule.p4}}</p>
            <p>{{rule.p5}}</p>
            <p>{{rule.p6}}</p>
            <p class="text-right">{{rule.p7}}</p>
            <p class="text-right">{{rule.p8}}</p>
          </el-dialog>
        </div>
      </div>
      <div class="smallIcon" v-show="icon" @mouseenter="display">
        <img src="../../../assets/login/btn-dialog.png" />
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import loginBoardNormal from './login-normal.vue';
import fallbackImage from './../fallback-image.vue';
import { getIndex } from '@/api/login';
export default {
  name: 'login',
  components: {
    loginBoardNormal,
    fallbackImage
  },
  data() {
    return {
      loading: true,
      isLoading: true,
      BASE_API: this.$store.getters.objApi.BASE_API,
      competentData: {
        showDefaultCenter: false,
        showDefaultHeader: false
      },
      active: 0,
      seen: false,
      dialogVisible: true,
      message: true,
      icon: false
    };
  },
  computed: {
    imgCarousel() {
      return this.competentData.centerImgUrl
        ? this.competentData.centerImgUrl.split(',')
        : [];
    },
    otherConfig() {
      return this.$store.getters.objApi.otherConfig;
    },
    rule() {
      return this.$store.getters.objApi.rule;
    }
  },
  created() {
    this.getIndex();
    if (JSON.stringify(this.rule) === '{}') {
      this.message = false;
    } else {
      this.message = true;
    }
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.loading = false;
        this.isLoading = false;
      }, 100);
    });
  },
  methods: {
    getIndex() {
      getIndex()
        .then(res => {
          this.competentData = res.data;
          if (!this.competentData.centerImgUrl) {
            this.competentData.showDefaultCenter = true;
          }
          if (!this.competentData.logoImgUrl) {
            this.competentData.showDefaultHeader = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.competentData.showDefaultCenter = true;
          this.competentData.showDefaultHeader = true;
        });
    },
    display() {
      this.message = true;
    },
    handleDialogClose() {
      this.message = false;
      this.icon = true;
    }
  }
};
</script>
<style lang="less">
.message {
  p {
    // font-weight: bold;
    line-height: 30px;
    font-size: 15px;
    text-indent: 1em;
    &:first-child {
      text-indent: 0em;
    }
  }
  .text-rigth{
    text-align: right;
  }
  .el-dialog__wrapper {
    width: 0;
    height: 0;
  }
  .el-dialog {
    position: fixed;
    bottom: 10px;
    left: 0;
    top: auto !important;
    margin: 0 auto;
  }
  .el-dialog--small {
    width: 600px;
  }
  .el-dialog__body {
    padding: 10px;
  }
  .el-dialog__header {
    background-color: #409eff;
    padding: 10px;
  }
  .el-dialog__title {
    color: #fff;
  }
  .el-dialog__headerbtn {
    top: 15px;
  }
  .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
  }
}
.smallIcon {
  position: fixed;
  left: 2px;
  bottom: 150px;
  width: 36px;
  height: 36px;
  line-height: 40px;
  background: #409eff;
  text-align: center;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/login/components/index-normal.vue